import BusinessesList from './BusinessesList'

export default BusinessesList